<template>
  <div>
    <v-card>
      <v-card-title>Datei laden</v-card-title>
      <v-card-subtitle
        >Bitte wählen Sie den Schichtplan mit der entsprechenden Schaltfläche
        aus</v-card-subtitle
      >

      <div>
        <input type="file" @change="processFile" value="C:\\Daten\\plan.xlsx" />
      </div>

      <div
        class="drop"
        @drop="filedrop"
        @dragover="dragover"
        style="height: 500px"
      >
        ... oder alternativ die Datei hier in die Anwendung ziehen.
      </div>
    </v-card>

    <v-card-text v-if="filename !== undefined">
      Datei:
      <v-chip
        class="ma-2"
        close
        color="secondary"
        text-color="white"
        @click:close="resetFile"
      >
        <v-avatar left>
          <v-icon>mdi-file</v-icon>
        </v-avatar>
        {{ filename }}
      </v-chip>

      <div class="progress" v-if="loading == true">
        <div class="indeterminate"></div>
      </div>
    </v-card-text>
  </div>
</template>

<style scoped>
.drop {
  border: 2px dashed #bbb;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
  padding: 30px;
  text-align: center;
  font: 20pt bold;
  color: #bbb;
}
</style>

<script>
import XLSX from "xlsx";

export default {
  props: ["template"],
  data: function () {
    return {
      filetemplates: [
        {
          id: "ep_landshut",
          label: "EP Landshut",
        },
      ],
      uploadfile: undefined,
      filename: undefined,
      templatePrefix: undefined,
      templateName: undefined,
      loading: false,
      showTemplate: true,
    };
  },
  mounted() {
    // set template if undefined
    if (this.template != undefined) {
      this.templatePrefix = this.template;
    }
  },
  methods: {
    // reset file
    resetFile: function () {
      this.filename = undefined;
      this.uploadfile = undefined;
      this.$emit("reset");
    },
    // process file
    processFile: function (event) {
      this.filename = event.target.files[0].name;
      this.uploadfile = event.target.files[0];
      this.handleFile();
    },
    // handle file
    handleFile: function () {
      // set let iables such as day of month

      let self = this;

      this.loading = true;

      // read file with file reader
      let reader = new FileReader();
      reader.onload = function (event) {
        let data = event.target.result;
        let plan = {
          sheets: [],
          data: [],
        };
        let workbook = XLSX.read(data, {
          type: "binary",
        });

        // eslint-disable-next-line no-console
        console.log(JSON.stringify(workbook.SheetNames));

        for (
          let sheetNumber = 0;
          sheetNumber < workbook.SheetNames.length;
          sheetNumber++
        ) {

        // eslint-disable-next-line no-console
        console.log(`Process Excel Sheet: ${workbook.SheetNames[sheetNumber]} - ${workbook.SheetNames[sheetNumber].length} - ${!isNaN(parseInt(workbook.SheetNames[sheetNumber]))}`);
       
       if (
            workbook.SheetNames[sheetNumber].length == 4 &&
            !isNaN(parseInt(workbook.SheetNames[sheetNumber]))
          ) {

            // eslint-disable-next-line no-console
            console.log(`Accept: ${workbook.SheetNames[sheetNumber]}`);
       
            let XL_row_object = XLSX.utils.sheet_to_json(
              workbook.Sheets[workbook.SheetNames[sheetNumber]],
              {
                header: 1,
              }
            );
            plan.data.push(XL_row_object);
            plan.sheets.push(workbook.SheetNames[sheetNumber]);
          }
        }

        self.$emit("selected", self.templatePrefix, JSON.stringify(plan));
        self.loading = false;
      };

      // handle file reader error
      reader.onerror = function (event) {
        alert(
          "Datei konnte nicht gelesen werden! Code " + event.target.error.code
        );
      };
      reader.readAsBinaryString(this.uploadfile);
    },
    // handle drag over
    dragover: function (event) {
      event.preventDefault();
    },
    // handle file drop
    filedrop: function (event) {
      event.preventDefault();
      if (event.dataTransfer.items) {
        if (event.dataTransfer.items.length > 0) {
          if (event.dataTransfer.items[0].kind === "file") {
            let file = event.dataTransfer.items[0].getAsFile();
            this.filename = file.name;
            this.uploadfile = file;
            this.handleFile();
          }
        }
      } else {
        if (event.dataTransfer.files.length > 0) {
          let file = event.dataTransfer.items[0].getAsFile();
          this.filename = file.name;
          this.uploadfile = file;
          this.handleFile();
        }
      }
    },
  },
};
</script>
